<template>
  <nav class="bg-white shadow-sm sticky top-0 z-50">
    <div class="container mx-auto px-4 py-3 flex justify-between items-center">
      <div class="text-xl font-bold text-gradient">
        <i class="fas fa-robot mr-2"></i>AIGC优化工具
      </div>
      <div class="hidden md:flex space-x-6 items-center">
        <button @click="goToDetection" :class="isDetectionActive ? 'active px-3 py-2 text-indigo-600 font-medium' : 'px-3 py-2 text-gray-600 hover:text-indigo-600 transition-colors'">一键降AI</button>
        <button @click="goToManual" :class="isManualActive ? 'active px-3 py-2 text-indigo-600 font-medium' : 'px-3 py-2 text-gray-600 hover:text-indigo-600 transition-colors'">人工降AI</button>
        <button @click="goToHistory" :class="isHistoryActive ? 'active px-3 py-2 text-indigo-600 font-medium' : 'px-3 py-2 text-gray-600 hover:text-indigo-600 transition-colors'">历史记录</button>

        <!-- 用户未登录时显示登录按钮 -->
        <template v-if="!authStore.token">
          <button @click="authStore.show()" class="px-4 py-1.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition">登录/注册</button>
        </template>

        <!-- 用户登录后显示用户信息 -->
        <div v-else class="relative">
          <button @click="toggleUserMenu" class="flex items-center space-x-2 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition user-menu">
            <img :src="authStore.user.avatar || '/a.svg'" alt="用户头像" class="w-8 h-8 rounded-full object-cover">
            <span class="text-gray-800">{{ authStore.user.name }}</span>
            <i class="fas fa-chevron-down text-gray-500 text-xs"></i>
          </button>
          <div v-if="showUserMenu" class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
            <div class="px-4 py-2 border-b border-gray-100">
              <div class="font-medium text-gray-800">{{ authStore.user.name }}</div>
            </div>
            <button @click="handleLogout" class="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 transition">
              <i class="fas fa-sign-out-alt mr-2"></i>退出登录
            </button>
          </div>
        </div>
      </div>
      <button class="md:hidden text-gray-600" @click="toggleMobileMenu">
        <i class="fas fa-bars text-xl"></i>
      </button>
    </div>

    <!-- 移动端菜单 -->
    <div class="md:hidden bg-white shadow-lg" v-if="showMobileMenu">
      <div class="px-4 py-2">
        <button @click="goToDetection" class="w-full text-left px-3 py-2" :class="isDetectionActive ? 'text-indigo-600 font-medium' : 'text-gray-600'">
          <i class="fas fa-magic mr-2"></i>一键降AI
        </button>
        <button @click="goToManual" class="w-full text-left px-3 py-2" :class="isManualActive ? 'text-indigo-600 font-medium' : 'text-gray-600'">
          <i class="fas fa-user-edit mr-2"></i>人工降AI
        </button>
        <button @click="goToHistory" class="w-full text-left px-3 py-2" :class="isHistoryActive ? 'text-indigo-600 font-medium' : 'text-gray-600'">
          <i class="fas fa-history mr-2"></i>历史记录
        </button>

        <div class="border-t border-gray-100 mt-2 pt-2">
          <template v-if="!authStore.token">
            <button @click="authStore.show(); showMobileMenu = false" class="w-full text-left px-3 py-2 text-gray-600">
              <i class="fas fa-sign-in-alt mr-2"></i>登录/注册
            </button>
          </template>
          <template v-else>
            <div class="px-3 py-2 border-b border-gray-100">
              <div class="font-medium text-gray-800">{{ authStore.user.name }}</div>
            </div>
            <button @click="handleLogout" class="w-full text-left px-3 py-2 text-red-600">
              <i class="fas fa-sign-out-alt mr-2"></i>退出登录
            </button>
          </template>
        </div>
      </div>
    </div>

    
  </nav>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { authStore } from '../utils/authStore'
import toast from '../utils/toast'
import { api } from '../utils/api'

const router = useRouter()
const route = useRoute()
const showMobileMenu = ref(false)
const showUserMenu = ref(false)
const isDetectionActive = ref(false)
const isManualActive = ref(false)
const isHistoryActive = ref(false)
 // 登出
const handleLogout = async () => {
  try {
    await api.fetch('/api/login/loginOut', { method: 'POST' });
    toast.show('您已成功退出');
  } catch (error) {
    console.error('退出登录失败:', error);
    // 即使退出请求失败，也继续清理前端状态
    toast.show('退出操作部分失败，请稍后重试');
  } finally {
    authStore.logout();
  }
};

// 导航方法
const goToDetection = () => { router.push('/optimize'); showMobileMenu.value = false }
const goToManual = () => { router.push('/manual'); showMobileMenu.value = false }
const goToHistory = () => { router.push('/history'); showMobileMenu.value = false }
const toggleMobileMenu = () => showMobileMenu.value = !showMobileMenu.value
const toggleUserMenu = () => showUserMenu.value = !showUserMenu.value

// 监听路由变化
watch(() => route.path, (newPath) => {
  isDetectionActive.value = newPath === '/optimize'
  isManualActive.value = newPath === '/manual'
  isHistoryActive.value = newPath === '/history'
}, { immediate: true })

// 点击外部关闭用户菜单
const handleClickOutside = (e) => {
  if (showUserMenu.value && !e.target.closest('.user-menu')) showUserMenu.value = false
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>